module.exports = __webpack_public_path__ + "static/media/длительное-проживание.0e259db4.jpg";